export default {
  data() {
    return {
      isPrintPreview: false
    }
  },
  methods: {
    // HTMLの指定エリア内を印刷する
    printTarget: function(id) {
      if (document.getElementById('print-container') && document.getElementById(id).innerHTML) {
        this.isPrintPreview = true
        document.getElementById('body').classList.add('is-preview-print')
        document.getElementById('print-container').innerHTML = document.getElementById(id).innerHTML
        const theme = document.getElementsByClassName('print-header-title')
        if (id === 'printToc') {
          // 目次一覧の時にテーマは表示させたくないため、非表示に設定する。
          for (let i = 0; i < theme.length; i++) {
            theme[i].style.display = 'none'
          }
        }
        window.print()
        if (id === 'printToc') {
          // 目次一覧の時にテーマを非表示にしていたため、次のことを考えて元の値を設定する。
          for (let i = 0; i < theme.length; i++) {
            theme[i].style.display = 'block'
          }
        }
        document.getElementById('body').classList.remove('is-preview-print')
        this.isPrintPreview = false
      } else {
      }
    },
    // PDFを印刷する
    printPDF: function(url) {
      const iframe = document.createElement('iframe')
      iframe.className = 'pdf-iframe'
      document.body.appendChild(iframe)
      iframe.style.display = 'none'
      iframe.onload = function() {
        iframe.focus()
        iframe.contentWindow.print()
        URL.revokeObjectURL(url)
      }
      iframe.src = url
    }
  }
}
